import { render, staticRenderFns } from "./CompradoresRecurrentesVsNuevos.vue?vue&type=template&id=3ab6458f"
import script from "./CompradoresRecurrentesVsNuevos.vue?vue&type=script&lang=js"
export * from "./CompradoresRecurrentesVsNuevos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports